    let spImgList = [
  // "https://cdn.shopify.com/s/files/1/0602/1057/7485/files/d9f56d90579743f0673e03a3b9bd7ec6.png?v=1721376367",
  "https://cdn.shopify.com/s/files/1/0602/1057/7485/files/8a2b426439ca91e3ccf05334d7b250c2.png?v=1721376367",
  "https://cdn.shopify.com/s/files/1/0602/1057/7485/files/07ad67ff28c7bf13cb8bdeae7c93ee94.png?v=1721376367",
];
function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )


     // 找到所有跳转套餐的锚点链接
  var links = document.querySelectorAll('a[href^="#shopping"]');
  links.forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault();

      const targetElement = document.getElementById('shopping');
      if (targetElement) {
        const offsetTop = targetElement.offsetTop;
        setTimeout(function() {
          window.scroll({
            top: offsetTop * parseFloat($('div#root').css('zoom')),
            // behavior: 'smooth',
          });
        }, 100);
      }
    });
  });
    
let prods = window.product
function getCur(){
  // let color = $('#sp-color li.active').attr('data-val')
    let index = $('#sp-color li.active').attr('data-index')
   let color =  window.options_with_values[0].values[Number(index)]
  console.log(color)
  return prods.filter(item=> item.option1 == color)[0]
}
function changePrice(){
  let num = $('#2').val()
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
  $('#new').html(price)
  $('#old').html(compare)
  // let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  // $(".product-part .price-group sp-pro-offs").html(off_font);
}
    $('.buyBtn').click(function(){
      let num = $('#2').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
      $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    // style选项
    let colorOptions = $("#sp-color .option.active").index();

    $(".sp-product-card .sp-pro-img img")[0].src = spImgList[colorOptions];
    changePrice()
  });
    
    // 加入购物车
    addCart()
    function addCart() {
    // 加入购物车
    $('#addCart').click(function () {
      // do something here
      var data = {
        id: getCur().id,
        quantity: $('#2').val(),
      };
      
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $(".buy-car span").html(result.item_count);
          });
        },
        dataType: "json",
      });
      
      var img = $('.sp-pro-img img')
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('clone')
      $('.sp-part5').append(flyer)
      $('.clone').css({
        width: '796px',
        height: '711px',
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })
      $('.buy-car').addClass('shake')
      setTimeout(() => {
        $('.buy-car').removeClass('shake')
      }, 1000)
      let finish = $('.buy-car')
      $('.clone').animate(
        {
          top: finish[0].offsetTop / 2 + $('.sp-header-t').height(),
            left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        1000,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach() // 完成动画后移除克隆的图片
            }
          )
        }
      )
    })
  }
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      // var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    // 初始化
    alignmentFns.initialize()
    // 数量
    $('#2').change(function () {
      var number = Number($('#2').val())
      $('#new').html('')
      $('#old').html('')
      $('#new').html((number * Number(window.product[0].price / 100)).toFixed(2))
      $('#old').html((number * Number(window.product[0].compare_at_price / 100)).toFixed(2))
    })
    // 动画
    $('#goods-image_header_1').show()
    $('#goods-image_header_2').hide()
    $('#goods-image_header_3').show()
    $('#goods-image_header_4').hide()
    let header_flag = false
    setInterval(() => {
      header_flag = !header_flag
      if (header_flag) {
        $('#goods-image_header_1').hide()
        $('#goods-image_header_2').show()
        $('#goods-image_header_3').hide()
        $('#goods-image_header_4').show()
      } else {
        $('#goods-image_header_1').show()
        $('#goods-image_header_2').hide()
        $('#goods-image_header_3').show()
        $('#goods-image_header_4').hide()
      }
    }, 1000)
  })

 

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

 document.addEventListener('DOMContentLoaded', function() {
  lazyLoadImages();
preloadImages(spImgList);
  
});


  

  

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }


  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
    $('.sp_system').css('letter-spacing', '0px')
  } else if (isPC) {
    console.log('PC')
  } else {
    
  }
}

mainRender()
